import {combineLatest, Observable, of as observableOf, of, ReplaySubject} from 'rxjs';
import {Inject, Injectable} from '@angular/core';
import {CustomerInfo} from "@webmate-web-core/shared/types/customer";
import {CustomerApi} from "@webmate-web-core/shared/api/rest/customer.restapi";

@Injectable({
    providedIn: 'root',
})
export class CustomerService {
    constructor(private customerApi: CustomerApi) {
    }

    getCustomerInfo$(): Observable<CustomerInfo> {
        return this.customerApi.getCustomerInfo$();
    }
}
